import React, { useEffect, useState } from 'react';
import { ExternalLink, Youtube as YoutubeIcon, PlayCircle } from 'lucide-react';
import { api } from '../lib/api';

const YouTubeLatest = () => {
    const [items, setItems] = useState([]);
    const [active, setActive] = useState(null);

    useEffect(() => {
        api.get('/youtube-latest').then((r) => setItems(r.data.items || [])).catch(() => {});
    }, []);

    if (!items || items.length === 0) return null;
    const top = items.slice(0, 3);

    return (
        <section className="border-t border-white/10" data-testid="youtube-latest-section">
            <div className="container-page py-24 md:py-32">
                <div className="flex items-end justify-between gap-6 mb-12 flex-wrap">
                    <div>
                        <div className="label-caps text-brand-primary mb-4 flex items-center gap-2">
                            <YoutubeIcon className="h-4 w-4" /> / Latest on YouTube
                        </div>
                        <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl">
                            Fresh from<br />the shop floor.
                        </h2>
                    </div>
                    <a
                        href="https://www.youtube.com/@DryIceBulls"
                        target="_blank"
                        rel="noreferrer"
                        className="label-caps text-white/70 hover:text-white transition-colors inline-flex items-center gap-2"
                        data-testid="youtube-latest-channel-link"
                    >
                        Full channel <ExternalLink className="h-4 w-4" />
                    </a>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="youtube-latest-grid">
                    {top.map((v) => (
                        <button
                            key={v.video_id}
                            onClick={() => setActive(v)}
                            className="group text-left border border-white/10 hover:border-brand-primary transition-colors bg-brand-surface"
                            data-testid={`youtube-latest-card-${v.video_id}`}
                        >
                            <div className="aspect-video relative bg-brand-bg overflow-hidden">
                                <img
                                    src={v.thumbnail}
                                    alt={v.title}
                                    className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
                                />
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <PlayCircle className="h-14 w-14 text-white drop-shadow-lg group-hover:scale-110 transition-transform" strokeWidth={1.25} />
                                </div>
                            </div>
                            <div className="p-5">
                                <h3 className="font-display font-black text-base md:text-lg uppercase tracking-tight text-white line-clamp-2 group-hover:text-brand-primary transition-colors">
                                    {v.title}
                                </h3>
                                <div className="text-xs text-white/40 mt-2">
                                    {v.published_at ? new Date(v.published_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {active && (
                <div
                    className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
                    onClick={() => setActive(null)}
                    data-testid="youtube-latest-modal"
                >
                    <div className="w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-between mb-3">
                            <h3 className="font-display font-black text-lg md:text-xl text-white line-clamp-1">{active.title}</h3>
                            <button
                                onClick={() => setActive(null)}
                                className="label-caps text-white/70 hover:text-white"
                                data-testid="youtube-latest-modal-close"
                            >
                                Close ✕
                            </button>
                        </div>
                        <div className="aspect-video border border-white/10">
                            <iframe
                                src={`${active.embed_url}?autoplay=1`}
                                className="w-full h-full"
                                title={active.title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default YouTubeLatest;
